<template>
  <div>
    <div class="absolute inset-0 flex flex-col items-center">
      <div class="relative flex-1 w-full">
        <router-view v-slot="{ Component }" class="relative w-full h-full">
          <transition :name="transitionName">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </transition>
        </router-view>
      </div>

      <app-page-menu>
        <router-link
          :to="{
            name: 'MasterPlansFloors',
            params: { floorId: $route.query.floorId || $route.params.floorId || 6 },
            query,
          }"
          active-class="text-escent"
        >
          Floor Plans
        </router-link>
        <router-link
          :to="{
            name: 'MasterPlansUnits',
            params: { unitName: $route.query.unitName || $route.params.unitName || 'A1' },
            query,
          }"
          active-class="text-escent"
        >
          Unit Plans
        </router-link>
        <router-link
          :to="{
            name: 'MasterPlansCompare',
            query,
          }"
          active-class="text-escent"
        >
          Compare
        </router-link>
        <router-link
          :to="{
            name: 'MasterPlansMatrix',
            query,
          }"
          active-class="text-escent"
        >
          Matrix
        </router-link>
      </app-page-menu>
    </div>
  </div>
</template>

<script>
import { PrinterIcon } from '@zhuowenli/vue-feather-icons'
import AppPageMenu from '@/components/AppPageMenu.vue'

export default {
  name: 'MasterPlans',
  components: {
    PrinterIcon,
    AppPageMenu,
  },
  data () {
    return {
      transitionName: 'page-scale-down',
    }
  },
  computed: {
    query () {
      return {
        floorId: this.$route.params.floorId || this.$route.query.floorId,
        unitName: this.$route.params.unitName || this.$route.query.unitName,
      }
    },
  },
  watch: {
    '$route' (to, from) {
      this.transitionName = to.meta.pageOrder > from.meta.pageOrder ? 'page-scale-down' : 'page-scale-up'
    },
  },
}
</script>
